import type { facilitatorPanelData } from "@/features/facilitatorPanel/types.props";
import axiosInstance from "@/lib/axios";

export const getFacilitatorPanelData =
    async (): Promise<facilitatorPanelData> => {
        const { data } = await axiosInstance.get<facilitatorPanelData>(
            `/reports/panel/facilitator/`,
        );
        return data;
    };
